import { SolarMap } from '@shared/components/solar-map/solar-map';
import { Component, inject } from '@angular/core';
import { CurrentOrganizationStore } from '@features/organizations/store/current-organization.store';
import { ActionNeededComponent } from '@features/dashboard/components/action-needed/action-needed';
import { DashboardChartsComponent } from '@features/dashboard/components/dashboard-charts/dashboard-charts';
import { LatestActivityComponent } from '@features/dashboard/components/latest-activity/latest-activity';
import { DashboardMetricsComponent } from '@features/dashboard/components/dashboard-metrics/dashboard-metrics';
import { ActiveCampaignsComponent } from '@features/dashboard/components/active-campaigns/active-campaigns';

// No header actions: "Analysen" and "Adressen" are one click away in the sidebar,
// and repeating them as buttons only competed with the page's own content.
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    DashboardMetricsComponent,
    SolarMap,
    ActionNeededComponent,
    DashboardChartsComponent,
    LatestActivityComponent,
    ActiveCampaignsComponent,
  ],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class Dashboard {
  protected readonly currentOrgStore = inject(CurrentOrganizationStore);
}
